var FlowDirectionItem = /** @class */ (function () {
    function FlowDirectionItem(value, name) {
        this.name = '';
        this.value = value;
        this.name = name;
    }
    return FlowDirectionItem;
}());
export { FlowDirectionItem };
